import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import Layout from "../../../components/Layouts/Layouts/Layout";
import MasterNavigationBar from "../../../components/Layouts/Layouts/MasterServicesLayout";
import { getURLbyEndPoint } from "../../../store/api";
import { getAuthUserCookie } from "../../../store/services";

const MarketingInterest = () => {
  const navigate = useNavigate();
  const [notificationData, setNotificationData] = useState([]);

  const fetchNotification = async () => {
    try {
      const response = await axios.get(
        getURLbyEndPoint("getNotificationStatus")
      );
      console.log(response);
      if (response.status === 200) {
        const data = response.data.data;
        setNotificationData(data);
      } else {
        alert("Failed to fetch notification data.");
      }
    } catch (error) {
      alert("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchNotification();
  }, []);
  return (
    <Layout>
      <MasterNavigationBar>
        <div className="d-flex flex-column px-3">
          <DashboardHeader
            heading="MARKETING INTEREST"
            backUrl="/master-profile"
          />
          <hr />
          <div className="d-flex justify-content-around mb-2">
            <button
              type="button"
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1 position-relative d-inline-flex align-items-center justify-content-center"
              style={{ width: "35%" }}
              onClick={() => {
                navigate("/master-marketing-demo-request");
              }}
              disabled={
                !getAuthUserCookie().accessList.includes("MarketingTrialReq")
              }
            >
              MARKETING DEMO REQUEST
              <span
                className="badge bg-primary position-absolute fs-6"
                style={{ top: "-8px", right: "-8px" }}
              >
                {notificationData.marTrial !== 0 ? notificationData.marTrial : null}
              </span>
            </button>
            <button
              type="button"
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1 position-relative d-inline-flex align-items-center justify-content-center"
              style={{ width: "35%" }}
              onClick={() => {
                navigate("/master-legalwing-interest");
              }}
              disabled={
                !getAuthUserCookie().accessList.includes("legalWingReq")
              }
            >
              LEGAL WING REQUEST
              <span
                className="badge bg-primary position-absolute fs-6"
                style={{ top: "-8px", right: "-8px" }}
              >
                {notificationData.legalWingReq !== 0 ? notificationData.legalWingReq : null}
              </span>
            </button>
          </div>
          <hr />
          <div className="d-flex justify-content-around mb-2">

            <button
              type="button"
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1 position-relative d-inline-flex align-items-center justify-content-center"
              style={{ width: "35%" }}
              disabled={
                !getAuthUserCookie().accessList.includes("patronMemberReq")
              }
            >
              PATRON MEMBERSHIP REQUEST
              <span
                className="badge bg-primary position-absolute fs-6"
                style={{ top: "-8px", right: "-8px" }}
              >
                {notificationData.patronMem !== 0 ? notificationData.patronMem : null}
              </span>
            </button>
          </div>
        </div>
      </MasterNavigationBar>
    </Layout>
  );
};

export default MarketingInterest;